import { render, staticRenderFns } from "./HealthPrediction.vue?vue&type=template&id=2be84fdd&scoped=true"
import script from "./HealthPrediction.vue?vue&type=script&lang=js"
export * from "./HealthPrediction.vue?vue&type=script&lang=js"
import style0 from "./HealthPrediction.vue?vue&type=style&index=0&id=2be84fdd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be84fdd",
  null
  
)

export default component.exports